import React from 'react';
import { Box, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import Close from '@gamiphy/icons/Close';
import ButtonFactory from './ButtonFactory';

export type Props = {
  focus?: boolean
};

const Button: React.FC<Props> = observer(({ focus }) => {
  const open = UiStore.opened;

  const onOpen = () => {
    UiStore.open();
  };
  const onClose = () => {
    UiStore.close();
  };

  return (
    <Box
      sx={{
        cursor: 'pointer',
        boxSizing: 'content-box',
        border: (theme) => `1px solid ${theme.palette.text.secondary}`,
        padding: '1px',
        borderRadius: '50%',
        display: 'flex',
      }}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        onClick={() => (open ? onClose() : onOpen())}
        sx={{
          backgroundColor: (theme) => (open ? theme.palette.text.secondary : 'unset'),
          borderRadius: '50%',
          height: '2.2rem',
          width: '2.2rem',
          display: 'flex',
        }}
      >
        {
          open
            ? <Close width={7} height={7} style={{ margin: 8, fill: '#1976d2', stroke: '#1976d2' }} />
            : (
              <ButtonFactory focus={focus} />
            )
        }
      </Grid>
    </Box>
  );
});

export default Button;
